import { getRemoteUserData, setRemoteUserData } from "../Shared/userDataApi";

const ATTESTATION_KEY = "attestation";

function getTodayAsYYYYMMDD() {
  return new Date().toISOString().split("T")[0];
}

function olderThanAYear(setAtDate) {
  const lastAttestationDate = new Date(setAtDate);
  const todayDate = new Date(getTodayAsYYYYMMDD());

  const msInADay = 1000 * 60 * 60 * 24;
  const diffInDays = (todayDate - lastAttestationDate) / msInADay;
  return diffInDays > 365;
}

export async function needToShowAttestation() {
  try {
    const attestation = await getRemoteUserData(ATTESTATION_KEY);
    if (attestation === null) {
      return true;
    }

    // Retrieve the tamper-proof server-side timestamp.
    // e.g. 2026-08-19 12:30:08 UTC
    const setAtTimestamp = attestation["setAtTimestamp"];
    const setAtDate = setAtTimestamp.split(" ")[0];
    return olderThanAYear(setAtDate);
  } catch (error) {
    console.log("Error getting attestation", error);
    return false;
  }
}

export async function storeAttestation() {
  // Store an empty dictionary. The server will add a special key with
  // a tamper-proof timestame that we'll use later.
  const value = {};
  await setRemoteUserData(ATTESTATION_KEY, value);
}
